// extracted by mini-css-extract-plugin
export var container = "_2r-0";
export var icon = "_2r-1";